export default "__VITE_ASSET__fb477eed__"